'use strict';

module.exports = function count() {
  var arrayLength = 0;

  if (Array.isArray(this.items)) {
    arrayLength = this.items.length;
  }

  return Math.max(Object.keys(this.items).length, arrayLength);
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/count.js
// module id = 1640
// module chunks = 2